<template>
	<section
		v-editable="blok"
		class="container"
		:aria-label="blok.title ?? null"
	>
		<div class="mb-4">
			<Component :is="headingTag" class="typo-h2">
				{{ blok.title }}
			</Component>
			<p v-if="blok.subtitle">
				{{ blok.subtitle }}
			</p>
		</div>

		<div class="grid lg:grid-cols-2 gap-5">
			<StoryblokComponent
				v-for="item in blok.children"
				:key="item._uid"
				:blok="item"
			/>
		</div>
	</section>
</template>

<script setup lang="ts">
	import type {PresentationalTilesStoryblok} from '@/storyblok/types';

	interface Props {
		blok: PresentationalTilesStoryblok
		headingTag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
	}

	withDefaults(defineProps<Props>(), {headingTag: 'h2'});
</script>
